// extracted by mini-css-extract-plugin
export default {"root":"AllStats_root__76Yrc","content":"AllStats_content__XAym2","chart":"AllStats_chart__1ljlJ"};